/**
 * @prettier
 */

import React from 'react';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { Link } from '@zola/zola-ui/src/components/Link';
import Layout from '../Layout/Layout';
import styles from './styles.module.less';

const CartError = ({ closeModal }) => {
  return (
    <div className={styles.box}>
      <Layout.Header>Please check your cart</Layout.Header>
      <Layout.Text>
        Your cart contains items and they need to be removed or checked out before you can start
        customizing your free sample!
      </Layout.Text>
      <div className={styles.buttons}>
        <ButtonV2 variant="secondary" onClick={closeModal}>
          Continue Shopping
        </ButtonV2>
        <Link href="/cart/checkout">
          <ButtonV2 variant="primary">Go to Checkout</ButtonV2>
        </Link>
      </div>
    </div>
  );
};

export default CartError;
